import Gauge from '@/components/Gauge';

import { Text } from '@simplywallst/ui-core';

import { formatterPercentage } from '@/utilities/format';

import { Card } from '../Card';

export interface Props {
  portfolioValue: number | null;
  marketValue: number | null;
}

export const DividendYield = ({ portfolioValue, marketValue }: Props) => {
  return (
    <Card
      title="Dividend Yield"
      description={
        <Text color="inherit" typography="xSmall">
          This chart compares your portfolio's Dividend Yield with the market
          average. The Portfolio Dividend Yield is calculated as the sum of the
          product of shares and dividend per share, divided by the sum of the
          product of shares and holding price. This metric offers insight into
          your portfolio's capacity to generate income. A higher yield indicates
          a stronger income return relative to the stock price, suggesting a
          focus on income-generating investments. Conversely, a lower yield may
          point to growth-focused holdings. Use this chart to evaluate how your
          portfolio's income generation compares to market trends, helping
          balance income and growth in your investment strategy.{' '}
          <a
            href="https://support.simplywall.st/hc/en-us/articles/9423775242383-Understanding-the-New-Portfolio-Analysis-Calculations"
            rel="noreferrer nofollow"
            target="_blank"
          >
            Learn more
          </a>
        </Text>
      }
    >
      <Gauge
        keys={['portfolio', 'market']}
        entities={{
          portfolio: portfolioValue,
          market: marketValue,
        }}
        numTicks={5}
        title="Dividend Yield"
        from={0}
        to={0.08}
        formatter={formatterPercentage}
      />
    </Card>
  );
};
